import { ApiClientError } from "@/api/api-client-error.ts";
import { NoApplicationRightsError } from "@/lib/errors/auth/no-application-rights-error.ts";
import { SessionExpiredError } from "@/lib/session-expired-error.ts";

const EXPECTED_API_CLASSIFICATIONS = new Set<ApiClientError["classification"]>([
  "authentication",
  "domain",
  "expected-status",
  "form-validation",
]);

export function isExpectedError(error: unknown): boolean {
  if (error instanceof SessionExpiredError || error instanceof NoApplicationRightsError) {
    return true;
  }

  return error instanceof ApiClientError && EXPECTED_API_CLASSIFICATIONS.has(error.classification);
}

export function isUnexpectedError(error: unknown): boolean {
  return !isExpectedError(error);
}

export function shouldThrowToErrorBoundary(error: unknown): boolean {
  return error instanceof SessionExpiredError || error instanceof NoApplicationRightsError || isUnexpectedError(error);
}

export function shouldRetryRequest(failureCount: number, error: unknown): boolean {
  if (failureCount >= 1 || isExpectedError(error)) {
    return false;
  }

  return error instanceof ApiClientError && (error.status === undefined || error.status >= 500);
}
